
import React from 'react';
import AnimateInView from '@/components/ui/animate-in-view';

const FenceHero = () => {
  return (
    <section className="bg-forti-fi-deepteal py-20 px-4" aria-labelledby="fence-heading">
      <div className="container mx-auto max-w-4xl text-center">
        <AnimateInView animation="fade-in">
          <h1 id="fence-heading" className="text-white mb-6">
            Securing the Edge That Guards Your Boundaries
          </h1>
          <p className="text-white/90 text-xl md:text-2xl mb-8">
            Turn Your Fence from a Boundary to a Sentinel
          </p>
        </AnimateInView>
      </div>
    </section>
  );
};

export default FenceHero;
